import React, { useEffect, useRef, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Notify from '../components/Notify';
import Header from './Header';
import SideBarMenu from '../components/Header/SideBarMenu';
import { isEmpty, STATUS_MSG, storeUser } from '../Services/config/globals';
import { notifySet, userSet } from '../Services/Actions/CommonActions';
import { getCategories } from '../Services/Utils/ServiceProviderApis';
import { viewStartUp } from '../Services/Utils/StartupApis';

export default function Startup() {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [categoryData, setCategoryData] = useState([]);
  const [unreadCount, setUnReadCount] = useState('');
  const countRef = useRef(unreadCount);

  const navigate = useNavigate();

  useEffect(() => {
    if (isEmpty(user)) {
      navigate('/login');
      dispatch(notifySet({
        type: 'error',
        message: STATUS_MSG.sessionExpired
      }));
    } else if (user.view.roleView.id !== 2) {
      navigate('/login');
      dispatch(notifySet({
        type: 'error',
        message: STATUS_MSG.authenticationRequired
      }));
    } else if (!isEmpty(user)) {
      const sideBarCategories = async () => {
        const params = {
          start: 0,
          recordSize: ''
        };
        await getCategories({ active: true }, params, 'private').then((responseJson) => {
          const { list, status, message } = responseJson;
          if (status === true) {
            setCategoryData(list);
          } else {
            dispatch(
              notifySet({ type: 'error', message })
            );
          }
        });
      };
      if (user?.view.roleView.id !== 1) {
        sideBarCategories();
      }
    }
  }, [user]);

  useEffect(() => {
    viewStartUp({ id: user.view.id }).then((response) => {
      const { view } = response;
      user.view.eventView = view.eventView;
      countRef.current = view.unreadCount;
      user.view.unreadCount = view.unreadCount;
      storeUser(user);
      setUnReadCount(view.unreadCount);
      dispatch(userSet(user));
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      viewStartUp({ id: user.view.id }).then((response) => {
        const { view } = response;
        user.view.eventView = view.eventView;
        user.view.unreadCount = view.unreadCount;
        setUnReadCount(view.unreadCount);
        countRef.current === view.unreadCount ? '' : dispatch(notifySet({ type: 'success', message: 'New Notification received' }));
        countRef.current = view.unreadCount;
        storeUser(user);
        dispatch(userSet(user));
      });
    }, 60000);
    return () => clearInterval(interval);
  }, [user]);

  if (!isEmpty(user)) {
    return (
      <div className="app body-con">
        <Header unreadCount={unreadCount} categoryData={categoryData} />
        <Notify />
        <div className="wrapper">
          <SideBarMenu categoryData={categoryData} />
          <div id="content" className="content-box-con">
            <div className="container-fluid p-0">
              <div className="container mw-100 p-0">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
